import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  MaxLengthValidator,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { NgbAccordion } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from "../../../_services/alert.service";
import { environment } from "../../../../environments/environment";
import { ApiHttpService } from "../../../_services/api-http.service";
import {
  ColDef,
  FilterChangedEvent,
  FilterModifiedEvent,
  FilterOpenedEvent,
  GridApi,
  GridReadyEvent,
  ICellRendererParams,
  PaginationChangedEvent,
  RowClickedEvent,
} from 'ag-grid-community';
const { API_URL } = environment;
@Component({
  selector: 'app-charge-back',
  templateUrl: './charge-back.component.html',
  styleUrls: ['./charge-back.component.scss']
})
export class ChargeBackComponent implements OnInit {
  orvreport: FormGroup;
  form: FormGroup;
  Resultdata: any;
  merchantId:any;
  pageSize: number = 10;
  private filterObj: any = {};
  SingleRow: any;
  currentPage: number = 1;
  collectionSize: number = 10;
  private gridApi!: GridApi;
  selectedFile:any;
  public rowData: any[] = [
    // Add more rows here as needed...
  ];
  public columnDefs: ColDef[] = [
    { field: 'id', headerName: 'ID', hide: true },
    { field: "DATAId", tooltipField: 'sp_id', headerName: 'ID' },
    { field: 'merchantId', tooltipField: 'sp_id', headerName: 'Merchant Name'},
    { field: "chargeBack", tooltipField: 'sp_id', headerName: 'Charge Back (%)' },
    { field: 'createDate', tooltipField: 'sp_id', headerName: 'Create Date'},
  ];
  tableSelectedColumn: ColDef[] = [...this.columnDefs];
  loading: boolean = false;
  constructor(private  formBuilder: FormBuilder, private apiHttpService: ApiHttpService,private alertService: AlertService, ) {
  }
  ngOnInit(): void {
  }
  onGridReady(params: GridReadyEvent<any>) {
    debugger
  }
  reloadonGridReady(){
  }
  onFilterOpened(param: FilterOpenedEvent | any) {
    console.log("onFilterOpened----->", param);
  }
  onFilterModified(param: FilterModifiedEvent | any) {
    debugger
  }
  onRowDoubleClicked(param: RowClickedEvent | any) {
    debugger
  }
  downloadPdf(data:any) {
  }
  async onRowClicked(param: RowClickedEvent | any) {
    this.SingleRow = param.data
  }
  onPageSizeChanges($event: Event) {
  }
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 150,
    filter: false,
    resizable: true
  };
  onPaginationChange(param: PaginationChangedEvent | any) {
    this.gridApi.paginationGoToPage(param - 1)
  }
}